module.exports = __webpack_public_path__ + "static/media/numberline-snake.1bc51e4c.svg";